import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const FlowsDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment FlowsDisplayGridRowDataFragment on Flow {
  ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
